type QueenProps = {
    className?: string;
};

export default function Queen({ className }: QueenProps) {
    return (
        <svg
            className={className}
            viewBox="0 0 69 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.2001 41.6C27.139 39.2 46.1668 39.2 55.3001 41.6L59.1056 21.6L47.689 40L47.2323 17.44L39.3168 39.2L34.7501 16L30.1834 39.2L22.2679 17.44L21.8112 40L10.3945 21.6L14.2001 41.6Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M14.2012 41.5999C14.2012 44.7999 16.4845 44.7999 18.0067 47.9999C19.5289 50.3999 19.5289 49.5999 18.7678 53.5999C16.4845 55.1999 17.2456 57.5999 17.2456 57.5999C14.9623 59.9999 17.2456 61.5999 17.2456 61.5999C27.1401 63.1999 42.3623 63.1999 52.2567 61.5999C52.2567 61.5999 54.5401 59.9999 52.2567 57.5999C52.2567 57.5999 53.0178 55.1999 50.7345 53.5999C49.9734 49.5999 49.9734 50.3999 51.4956 47.9999C53.0178 44.7999 55.3012 44.7999 55.3012 41.5999C42.3623 39.1999 27.1401 39.1999 14.2012 41.5999Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M18.0059 47.9999C23.3336 46.3999 46.167 46.3999 51.4947 47.9999"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M18.7676 53.6C27.9009 52 41.6009 52 50.7342 53.6"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M9.63429 22.4C11.3157 22.4 12.6787 20.9673 12.6787 19.2C12.6787 17.4327 11.3157 16 9.63429 16C7.95289 16 6.58984 17.4327 6.58984 19.2C6.58984 20.9673 7.95289 22.4 9.63429 22.4Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M21.812 17.6C23.4934 17.6 24.8565 16.1673 24.8565 14.4C24.8565 12.6326 23.4934 11.2 21.812 11.2C20.1306 11.2 18.7676 12.6326 18.7676 14.4C18.7676 16.1673 20.1306 17.6 21.812 17.6Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M34.7515 16C36.4329 16 37.7959 14.5673 37.7959 12.8C37.7959 11.0327 36.4329 9.59998 34.7515 9.59998C33.0701 9.59998 31.707 11.0327 31.707 12.8C31.707 14.5673 33.0701 16 34.7515 16Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M47.689 17.6C49.3704 17.6 50.7334 16.1673 50.7334 14.4C50.7334 12.6326 49.3704 11.2 47.689 11.2C46.0076 11.2 44.6445 12.6326 44.6445 14.4C44.6445 16.1673 46.0076 17.6 47.689 17.6Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M59.8667 22.4C61.5481 22.4 62.9112 20.9673 62.9112 19.2C62.9112 17.4327 61.5481 16 59.8667 16C58.1853 16 56.8223 17.4327 56.8223 19.2C56.8223 20.9673 58.1853 22.4 59.8667 22.4Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
}
